import api from './api';

const customCodeService = {
    // List a partner's snippets for one platform (sync template).
    // Returns { snippets, scopeTypes } — scopeTypes = [{ scopeId, scopeType }] used by the template
    // (scopeId is the syncscope PK; scopeType is display only).
    list: (partnerId, syncTemplateId) =>
        api.get(`/admin/customcode?partnerId=${partnerId}&syncTemplateId=${syncTemplateId}`).then(r => r.data),

    get: (id) =>
        api.get(`/admin/customcode/${id}`).then(r => r.data),

    // `active` ('Y'/'N') gates whether the sync pipeline runs the snippet — see V367. Omitted on create
    // means active, matching the previous behaviour of "added code runs".
    // syncScopeIds is an ARRAY of syncscope.scopeid (V409) — a snippet can target several scopes. An
    // empty array means "every scope", which is what a null syncScopeId used to mean.
    // hotelIds is an ARRAY of hotel.hotelid (V427), on the same principle: an empty array means the
    // whole chain, which is what a null hotelId used to mean.
    create: (partnerId, syncTemplateId, name, code, accountId, hotelIds, syncScopeIds, active) =>
        api.post('/admin/customcode', { partnerId, syncTemplateId, name, code, accountId, hotelIds, syncScopeIds, active }).then(r => r.data),

    update: (id, name, code, accountId, hotelIds, syncScopeIds, active) =>
        api.put(`/admin/customcode/${id}`, { name, code, accountId, hotelIds, syncScopeIds, active }).then(r => r.data),

    remove: (id) =>
        api.delete(`/admin/customcode/${id}`).then(r => r.data),

    // Claude assistant for writing snippets. Rides on the existing POST /admin/customcode route with an
    // `action` discriminator — the /admin API Gateway is defined outside the infra repo, so a new action
    // on an existing path is addable where a new path is not.
    // messages: [{ role:'user'|'assistant', content }]  ->  { reply }
    assist: (messages, snippetContext) =>
        api.post('/admin/customcode', { action: 'assist', messages, snippetContext }).then(r => r.data),
};

export default customCodeService;
